import {
    ChangeDetectionStrategy,
    Component,
    DOCUMENT,
    inject,
    Renderer2,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CookieConsentService } from '@core/services/cookie-consent.service';
import { DeviceService } from '@core/services/device.service';
import { EnvironmentService } from '@core/services/environment.service';
import { EventTrackerService } from '@core/services/event-tracker.service';
import { MetadataService } from '@core/services/metadata.service';
import { UtmService } from '@core/services/utm.service';
import { WINDOW } from '@core/services/window.service';
import { WebVitalsService } from '@features/seo/services/web-vitals.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet],
})
export class AppComponent {
    private document = inject<Document>(DOCUMENT);
    private window = inject<Window>(WINDOW);
    private deviceService = inject(DeviceService);
    private environmentService = inject(EnvironmentService);
    private renderer2 = inject(Renderer2);
    private metadataService = inject(MetadataService);
    private webVitalsService = inject(WebVitalsService);
    private cookieConsentService = inject(CookieConsentService);
    private eventTrackerService = inject(EventTrackerService);
    private utmService = inject(UtmService);

    constructor() {
        this.removeNoJsClass();
        this.disableIndexingForNonProductionEnvironments();
        this.webVitalsService.collectWebVitals();
        this.eventTrackerService.setup();
    }

    private removeNoJsClass() {
        if (this.environmentService.isBrowser()) {
            this.renderer2.removeClass(this.document.body, 'no-js');
        }
    }

    private disableIndexingForNonProductionEnvironments() {
        if (!this.environmentService.isProduction()) {
            this.metadataService.setAttribute({
                name: 'robots',
                content: 'noindex, nofollow',
            });
        }
    }
}
